import { StoreState } from '../types'
import janus from './janus'

export function createRootReducer() {
    return janus
}

export function selectJanus(state: StoreState) {
    return state.janus
}